(ns client-portal.client.voice-insights.empty-state
  (:require [shared.core.style :as style]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.icon :as icon]))

(def base-container-style
  {:display :flex
   :flex-direction :column
   :align-items :center
   :justify-content :center
   :gap 24
   :width "100%"
   :flex 1})

(defn empty-icon []
  [:svg {:width 44
         :height 44
         :viewBox "0 0 44 44"
         :fill "none"
         :xmlns "http://www.w3.org/2000/svg"}
   [:path {:d "M36.9911 5L41.985 21.363L42 21.363L41.9737 37.34H0L0.026 21.378L0.0186068 21.3644L5.0911 5H36.9911ZM31.0931 23.0886C30.8612 23.0886 30.6704 23.2596 30.6704 23.4939L30.6803 26.5251C30.6803 27.5562 30.1394 28.1132 29.1194 28.1132L12.9583 28.1225C11.9384 28.1225 11.3409 27.4962 11.3409 26.4651L11.3952 23.525C11.3956 23.2906 11.208 23.1003 10.9762 23.0999H1.74199L1.69773 35.6458L40.3141 35.6515L40.3061 23.0893L31.0931 23.0886ZM6.10627 6.70131L1.69756 21.3637L11.3592 21.363C12.2864 21.363 13.0381 22.1229 13.0381 23.0603L13.0536 26.0236C13.0549 26.257 13.2424 26.4456 13.4733 26.4456L28.5701 26.447C28.8019 26.4472 28.9899 26.2573 28.9899 26.0229L28.9881 23.0603C28.9881 22.1229 29.7398 21.363 30.6671 21.363L40.323 21.363L35.7834 6.70392L6.10627 6.70131Z"
           :fill (style/alc-color "Icons/primary")}]])

(defn no-data-card [{:keys [text material-icon-type style]}]
  [:div {:style (merge base-container-style
                       style)}
   (if material-icon-type
     [icon/material-icon {:icon-type material-icon-type
                          :style {:font-size 44
                                  :color (style/alc-color "Icons/primary")}}]
     [empty-icon])
   [:span {:style {:color (style/alc-color "Text/primary_header")
                   :font-size 20
                   :font-weight 400
                   :line-height 1.4
                   :text-align :center}}
    (or text "No data available")]])

(defn no-chart-data [args]
  [no-data-card (merge {:material-icon-type :insert-chart
                        :text "No data for selected date range"
                        :style {:background-color :none
                                :padding "120px 24px"}}
                       args)])

(defn no-sessions-card [args]
  [no-data-card (merge {:text "No sessions to display"}
                       args)])

(defn no-charts-card [args]
  [no-data-card (merge {:text "No charts to display"}
                       args)])

(defn no-utterances-card [args]
  [no-data-card (merge {:text "No utterances to display"}
                       args)])

(defn no-orders-card [args]
  [no-data-card (merge {:text "No orders to display"}
                       args)])

(defn no-agent-card [args]
  [no-data-card (merge {:material-icon-type :auto-awesome
                        :text "No Agent Selected"}
                       args)])

(defn loading-card [args]
  [alc/card {:style (merge base-container-style
                           {:gap 12})}
   [alc/up-loader-with-label args]])

(defn loading-sessions-card [args]
  [loading-card (merge {:label "Loading Sessions..."}
                       args)])

(defn loading-orders-card [args]
  [loading-card (merge {:label "Loading Orders..."}
                       args)])

(defn loading-charts-card [args]
  [loading-card (merge {:label "Loading Charts..."}
                       args)])

(defn loading-utterances-card [args]
  [loading-card (merge {:label "Loading Utterances..."}
                       args)])

(defn loading-comparisons-card [args]
  [loading-card (merge {:label "Loading Comparisons..."}
                       args)])

(defn loading-reports-card [args]
  [loading-card (merge {:label "Loading Reports..."}
                       args)])

(defn loading-report-card [args]
  [loading-card (merge {:label "Loading Report..."}
                       args)])

(defn loading-data-card [args]
  [loading-card (merge {:label "Loading Data..."}
                       args)])



